/* eslint-disable import/first */
import React, { useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import { Redux } from 'spwa-ui-library';
import { deleteProfileCheck } from 'spwa-ui-library/esm/redux/store/profileSlice';
import {
  initiateAccountDeleteGA,
  confirmAccountDeletionGA,
} from 'spwa-ui-library/esm/utils/helperGA';
import { useNavigate, useLocation } from '@reach/router';
import { selectDesktop } from 'spwa-ui-library/esm/redux/store/appSlice';
import { FormattedMessage, useIntl } from 'react-intl';
import css from './index.module.scss';
const { useSelector, useDispatch } = Redux;
import Loader from '../../components/Loader';
import BackButton from '../../components/BackButton';
import WarningIcon from './images/warning.svg';

const DeleteAccount = ({ onClose, errorInDeleteAccount }) => {
  const isDesktop = useSelector(selectDesktop);
  const [isLoading, setIsLoading] = useState('');
  const intl = useIntl();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    initiateAccountDeleteGA();
  }, []);

  const handleClose = () => {
    confirmAccountDeletionGA('Cancel');
    if (isDesktop) {
      navigate(`/${intl.locale}/home`, { replace: true });
    } else {
      onClose();
    }
  };

  const deleteAccountHandler = () => {
    confirmAccountDeletionGA('Delete');
    setIsLoading(true);
    dispatch(deleteProfileCheck())
      .then((res) => {
        setIsLoading(false);
        // debugger;
        if (res?.error) {
          // if (res?.payload?.status === 403) {
          deleteAccountFailHandler();
          // }
        } else {
          deleteAccountFeedback();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const deleteAccountFeedback = () => {
    navigate(`/${intl.locale}/delete-account/feedback`, {
      state: {
        oldLocation: location?.state?.oldLocation,
      },
    });
  };

  const deleteAccountFailHandler = () => {
    if (isDesktop) {
      navigate(`/${intl.locale}/delete-account/fail`, {
        state: {
          oldLocation: location?.state?.oldLocation,
        },
      });
    } else {
      onClose();
      errorInDeleteAccount();
    }
  };

  return (
    <>
      {isLoading && <Loader />}
      <div className={css.deleteAccount}>
        {isDesktop && (
          <div className={css.buttonWrapper}>
            <div className={css.spacer}></div>
            <BackButton type="cross" className={css.customButton} handleBack={handleClose} />
          </div>
        )}
        <div className={css.main}>
          <div className={css.attentionIcon}>
            <img src={WarningIcon} alt="Delete an Account" />
          </div>
          <div className={css.deleteAccountContainer}>
            <div className={css.heading}>
              <FormattedMessage id="are_you_sure" />
            </div>
            <div className={css.delete_account_subheading}>
              <span>
                <FormattedMessage id="delete_account_subHeading1-1" />
              </span>
              <span>
                <FormattedMessage id="delete_account_subHeading1-2" />
              </span>
            </div>
            <div className={css.delete_account_subHeading_two}>
              <span>
                <FormattedMessage id="delete_account_subHeading2-1" />{' '}
              </span>
              <span className={css.mustardText}>
                <FormattedMessage id="delete_account_subHeading2-2" />{' '}
              </span>
              <span>
                <FormattedMessage id="delete_account_subHeading2-3" />
              </span>
            </div>
          </div>
          <div className={css.actionContainerDelete}>
            <Button
              variant="outlined"
              color="secondary"
              className={css.cancelBtn}
              onClick={handleClose}
            >
              <FormattedMessage id="cancel" />
            </Button>
            <Button
              variant="outlined"
              color="primary"
              className={css.deleteBtn}
              onClick={deleteAccountHandler}
            >
              <FormattedMessage id="confirm_delete" />
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteAccount;
